<div class="modal-header">
    <h4 class="modal-title">
        <i data-feather="plus"></i> Rezerve {{data ? 'Güncelle' : 'Ekle'}}
    </h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<form [formGroup]="certificateForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-xl-6 col-md-6 col-sm-12" [ngClass]="{'ng-select-disabled': data?.companyId}">
                <label for="company">Firma Seç</label>
                <ng-select [items]="companies" bindValue="id" bindLabel="companyName" formControlName="companyId"
                    [disabled]="!!data?.companyId"></ng-select>
            </div>

            <div class="col-xl-6 col-md-6 col-sm-12">
                <label for="company">Rezerv No</label>
                <input type="number" class="form-control" id="basicInput" formControlName="reservationNo" maxlength="7"
                    placeholder="Rezerv no gir." [min]="customerSetting.startCertificateNo" />
                <!-- <div *ngIf="certificateForm.controls['reservationNo'].invalid && certificateForm.controls['reservationNo'].touched"
                    class="text-danger">
                    Geçerli bir rezervasyon numarası giriniz (örn: 250001).
                </div> -->
                <div *ngIf="certificateForm.controls['reservationNo'].invalid && certificateForm.controls['reservationNo'].touched"
                    class="text-danger">
                    Geçerli bir rezervasyon numarası giriniz (6 veya 7 haneli, sadece rakam) örn; 250001, 2512500.
                </div>
                <div *ngIf="certificateForm.controls['reservationNo'].errors?.['min'] && certificateForm.controls['reservationNo'].touched"
                    class="text-danger">
                    Rezervasyon numarası en az {{ customerSetting.startCertificateNo }} olmalıdır.
                </div>

            </div>

            <div class="col-xl-6 col-md-6 col-sm-12" *ngIf="isSeriesAdd">
                <label for="company">Bitiş Rezerv No</label>
                <input type="number" class="form-control" id="basicInput" formControlName="endReservationNo"
                    maxlength="7" [min]="customerSetting.startCertificateNo" placeholder="Rezerv no gir." />
                <!-- <div *ngIf="certificateForm.controls['endReservationNo'].invalid && certificateForm.controls['endReservationNo'].touched"
                    class="text-danger">
                    Geçerli bir rezervasyon numarası giriniz (örn: 250001).
                </div> -->
                <div *ngIf="certificateForm.controls['endReservationNo'].invalid && certificateForm.controls['endReservationNo'].touched"
                    class="text-danger">
                    Geçerli bir rezervasyon numarası giriniz (6 veya 7 haneli, sadece rakam) örn; 250001, 2512500.
                </div>

                <div *ngIf="certificateForm.controls['endReservationNo'].errors?.['min'] && certificateForm.controls['endReservationNo'].touched"
                    class="text-danger">
                    Bitiş rezervasyon numarası en az {{ customerSetting.startCertificateNo }} olmalıdır.
                </div>
            </div>
        </div>
    </div>
</form>
<div class="modal-footer d-flex" [ngClass]="!data.data ? 'justify-content-between' : 'justify-content-end'">
    <div class="custom-control custom-control-primary custom-switch" *ngIf="!data.data">
        <p class="mb-50">Seri Ekle</p>
        <input type="checkbox" class="custom-control-input" id="customSwitch3" (change)="toggleSeries()" />
        <label class="custom-control-label" for="customSwitch3"></label>
    </div>

    <div class="row">
        <button type="button" class="btn btn-secondary mr-1" (click)="closeModal()">İptal</button>
        <button type="submit" class="btn btn-primary" [disabled]="certificateForm.invalid"
            (click)="onSubmit()">Kaydet</button>
    </div>
</div>